import React from 'react';
import { Link } from 'react-router-dom';  // <-- IMPORTANT
import './Footer.css';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer-section fontgeorgio">
      <div className="footer-container">
        {/* Left Logo + About */}
        <div className="footer-column">
          <img src="/assets/logo.png" alt="Shalisa Enterprise" className="footer-logo" />
          <p className="footer-about">
            <strong>JP Enterprise</strong> is leading company of travel solutions provide texi service and sedan cars like Swift, Ciaz.
          </p>
        </div>

        {/* Company Links */}
        <div className="footer-column">
          <h4>Company</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/services">Our Services</Link></li>
            <li><Link to="/workwith">We Work With</Link></li>
            <li><Link to="/cities">Serviceable Cities</Link></li>
          </ul>
        </div>

        {/* Quick Contacts */}
        <div className="footer-column">
          <h5 className="fw-bold mb-3">Quick Contacts</h5>
          <p className="text-dark"><FaPhone className="me-2" /> (+91) 8700115110 </p>
          <p className="text-dark"><FaPhone className="me-2" /> (+91) 9971149245 </p>
          <p className="text-dark"><FaEnvelope className="me-2" /> prakashmeena678@gmail.com</p>
          <p><FaMapMarkerAlt className="me-2" /> Shop no-40 , DDA Commercial Complex,<br /> Zamrud Pur GK 1, New Delhi-110048</p>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p className='text-center p-2'>
          Designed by <strong><a href='https://www.litostindia.in/' target="_blank" rel="noopener noreferrer">@Litost India</a></strong>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
